import Menu from './Compartido/Menu.jsx';
import ListaReservas from './CompartidoUsuario/ListaReservas.jsx';
import Footer from './Compartido/Footer.jsx';

const MisReservas = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <ListaReservas />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default MisReservas;
